
import BackgroundGray from "@/components/helpers/BackgroundGray.vue";
import Header from "@/components/partials/Header.vue";
import Footer from "@/components/partials/Footer.vue";
import Title from "@/components/style/Title.vue";
import CustomInput from "@/components/input-2/CustomInput.vue";
import CustomTextarea from "@/components/input-2/CustomTextarea.vue";
import Button from "@/components/input-2/Button.vue";

export default {
  components: {
    Button,
    CustomTextarea,
    CustomInput,
    Footer,
    Title,
    BackgroundGray,
    Header
  },
  data() {
    return {
      success: false,
      page: {},
      form: {
        first_name: '',
        last_name: ''
      }
    }
  },
  methods: {
    submit() {
      this.$refs.observer.validate()
          .then((res) => {
            this.$recaptcha.execute('login').then((res2) => {
              let form = {
                content: this.form.message,
                recaptcha: res2,
                email: this.form.email,
                name: this.form.name
              };

              if (!this.form.no_internal_code) {
                form.ids = [{
                  type: 'booking',
                  id: this.form.internal_code
                }];
              }

              this.$api.supportTicket.newTicket(form)
                  .then(() => {
                    this.success = true;
                  });
            })
                .catch(() => {
                  this.$refs.observer.reset();
                });
          })
          .catch(() => {

          });
    }
  },

  mounted() {
    this.$recaptcha.init();
  },
  async fetch() {
    // Use Promise.all to make both API calls concurrently
    const [pageResponse] = await Promise.all([
      this.$api.contents.query({
        multiple: false,
        code: 'contact'
      })
    ]);

    // Extract data from the responses
    this.page = pageResponse.data.content;

    // Set SEO data
    this.$store.commit('seo/setTitle', this.page.seo.title);
    this.$store.commit('seo/setDescription', this.page.seo.description);
    this.$store.commit('seo/setKeywords', this.page.seo.keywords);
    this.$store.commit('seo/setImage', this.page.image + '?format=webp');
    this.$store.commit('seo/setCanonical', this.localeRoute({
      name: 'index'
    }).fullPath);
  }
}
